import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, Title } from '../components/deck/Type';
const sources = ['PitchBook — global venture deal and exit coverage', 'Venture Forward — 1946 origins of institutional venture capital', 'Published global capital-deployment benchmarks', 'Institutional LP population estimates', 'Accelerator and venture-program population estimates', 'StartupFuel internal platform data (customers, assessments, Raiseboards)'];
const definitions = ['“10M+ ventures” refers to the broader venture-classifiable company universe. It does not mean all 10M companies received venture capital.', 'Ecosystem categories may overlap; an organization can appear in more than one category.', 'Annual historical venture-round counts are modeled estimates calibrated to current documented database coverage.', 'Current database counts change through new reporting and historical backfilling.', 'Customer-confidential data is isolated per organization and is not used to train shared third-party models.'];
export function SourcesSlide() {
  return <Slide index={16} data-id="element-273" data-mp="laznn1pp7s25">
      <Eyebrow data-id="element-274" data-mp="lapu545g32rp">Appendix</Eyebrow>
      <Title className="mt-[2.2vh]" data-id="element-275" data-mp="h8b9qfm4nuyb">Sources, definitions and methodology.</Title>

      <div className="mt-auto grid grid-cols-2 gap-[3.4vw]" data-id="element-276" data-mp="hafo5rhnkccu">
        <div data-id="element-277" data-mp="c8gkegi03dfd">
          <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#3B8CFF]" data-id="element-278" data-mp="c8q9m1v81gk0">
            Sources
          </span>
          <ul className="mt-[2vh] space-y-[1.3vh]" data-id="element-279" data-mp="2jf6qwyxh84k">
            {sources.map(s => <li key={s} className="border-b border-white/8 pb-[1.3vh] text-[clamp(10px,1.05vw,22px)] text-[#C3CBD9]" data-id="element-280" data-mp="2hlwl7p3w5rt">
                {s}
              </li>)}
          </ul>
        </div>

        <div data-id="element-281" data-mp="3ko0ax7raehqq">
          <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#D8A55A]" data-id="element-282" data-mp="3koiekpga3y8o">
            Definitions &amp; methodology
          </span>
          <ul className="mt-[2vh] space-y-[1.4vh]" data-id="element-283" data-mp="361tikxl8k371">
            {definitions.map(d => <li key={d} data-id="element-284" data-mp="3b165tjg0rca5">
                <Caption data-id="element-285" data-mp="3b2h453qp3rtv">{d}</Caption>
              </li>)}
          </ul>
        </div>
      </div>
    </Slide>;
}